// app/views/components/shared/ProgressStepper.tsx
type ProgressStepperProps = {
  stages: readonly string[]
  labels: Record<string, string>
  currentStage: string
}

export function ProgressStepper({ stages, labels, currentStage }: ProgressStepperProps) {
  const currentIndex = stages.indexOf(currentStage)

  return (
    <div className="flex items-center gap-1">
      {stages.map((key, i) => {
        const done = i <= currentIndex
        const isCurrent = i === currentIndex

        return (
          <div key={key} className="flex-1 flex flex-col gap-2">
            <div className={`h-1.5 rounded-full transition-colors ${
              done ? 'bg-foreground' : 'bg-muted'
            }`} />
            <span className={`text-[11px] ${
              isCurrent ? 'text-foreground font-medium' : done ? 'text-muted-foreground' : 'text-muted-foreground/60'
            }`}>
              {labels[key] || key}
            </span>
          </div>
        )
      })}
    </div>
  )
}
